import React from 'react';
import './InlineHexagonLoader.css';

/**
 * InlineHexagonLoader Component
 * A compact hexagon loader for inline use within cards and sections.
 * Unlike the full-page HexagonLoader, this version has relative positioning
 * and smaller dimensions suitable for embedding in content areas.
 */
const InlineHexagonLoader = () => {
    return (
        <div className="inline-hexagon-loader-container">
            {/* Hexagon animation container */}
            <div className="inline-hexagon-loader">
                <div className="inline-hexagon inline-hex-1a group2"></div>
                <div className="inline-hexagon inline-hex-2a group1"></div>
                <div className="inline-hexagon inline-hex-2b group2"></div>
                <div className="inline-hexagon inline-hex-3a group1"></div>
                <div className="inline-hexagon inline-hex-3b group1"></div>
                <div className="inline-hexagon inline-hex-3c group2"></div>
            </div>
        </div>
    );
};

export default InlineHexagonLoader;
